import React, {Fragment} from "react";
import BasicSelect from "../../../common/BasicSelect";

export default function ProactiveCommentSelectionModeSelect({ id, name, label, placeholder, defaultValue, input, meta }) {
    const options = [
        { 'id': 'ML_FILTER', 'name': 'Best comments (AI-powered)' },
        { 'id': 'SELECT_ALL', 'name': 'All comments' },
    ]

    return(
        <Fragment>
            <BasicSelect
                id={id}
                name={name}
                label={label}
                placeholder={placeholder}
                defaultValue={defaultValue}
                options={options}
                input={input}
                meta={meta} />
        </Fragment>
    )
}
